export default __webpack_public_path__ + "assets/knowledgeTreeMode.68cab67a.gif";